// Visit The Stimulus Handbook for more details
// https://stimulusjs.org/handbook/introduction
//
// This example controller works with specially annotated HTML like:
//
// <div data-controller="hello">
//   <h1 data-target="hello.output"></h1>
// </div>

import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ['body']

  connect() {
    document.addEventListener('user-shoe:created', this.updateFavorites.bind(this))
    document.addEventListener('user-shoe:destroyed', this.updateFavorites.bind(this))
  }

  disconnect() {
    document.removeEventListener('user-shoe:created', this.updateFavorites.bind(this))
    document.removeEventListener('user-shoe:destroyed', this.updateFavorites.bind(this))
  }


  updateFavorites() {
    fetch(this.data.get('url')).then(response => response.text()).then(html => {
      this.bodyTarget.innerHTML = html
    })
  }

  favoriteWasRemoved(event) {
    event.currentTarget.parentElement.outerHTML = ''

    this.updateFavorites()
  }
}